import axios from '../../../axiosConfig';

export async function getUserInfo(config = {}) {
    return await axios.get(`/v1/user/info`, config);
}

export async function getUsers(config = {}) {
    return await axios.get(`/v1/user`, config);
}

export async function getUserById(id, config = {}) {
    return await axios.get(`/v1/user/${id}`, config);
}

export async function createUser(data, config = {}) {
    return await axios.post(`/v1/user`, data, config);
}

export async function updateUser(data, config = {}) {
    return await axios.patch(`/v1/user/${data.id}`, data, config);
}

const functions = {getUserInfo, getUsers, createUser, updateUser, getUserById }
export default functions